import { useDispatch } from 'react-redux';
import { openModal } from 'state/modal/modalSlice';
import { editNewElementProps } from 'state/newElement/newElementSlice';
import FenceCanvasHeader from './FenceCanvasHeader/FenceCanvasHeader';
import FenceCanvasBody from './FenceCanvasBody/FenceCanvasBody';
import FenceCanvasFooter from './FenceCanvasFooter/FenceCanvasFooter';
import FenceCanvasModals from './FenceCanvasModals/FenceCanvasModals';

import style from './FenceCanvas.module.scss';

const FenceCanvas = () => {
  const dispatch = useDispatch();

  const openAddElementModal = (elementName = null) => {
    if (elementName) {
      dispatch(editNewElementProps({ activeName: elementName }));
    }

    dispatch(openModal('add-element'));
  };

  return (
    <div className={style.canvas}>
      <FenceCanvasHeader onOpenAddElementModal={openAddElementModal} />
      <FenceCanvasBody onOpenAddElementModal={openAddElementModal} />
      <FenceCanvasFooter />
      <FenceCanvasModals />
    </div>
  );
};

export default FenceCanvas;
